import React from 'react';

export default class Page5 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>MAINTAINING RESILIENCE – A PRACTICAL GUIDE
                                            </div>
                                            <div className="border_subtitle">Step One – Estimate the impact of
                                                the stressful event
                                            </div>
                                            <p>A useful way of gauging this is to use the ‘ABCs of Human Needs’
                                                – ask yourself if whatever
                                                situation’s worrying you now violates any of these:</p>
                                            <p><span className="brown brownbold">Accomplishment</span> – The
                                                need to achieve worthwhile goals.</p>
                                            <p><span className="brown brownbold">Belonging</span> – The need to
                                                define oneself through relationships with others.</p>
                                            <p><span className="brown brownbold">Comfort</span> – The need for
                                                calm and security in life.</p>
                                            <p><span className="brown brownbold">Dependability</span> – The need
                                                for predictability and stability.</p>
                                            <p><span className="brown brownbold">Esteem</span> – The need to
                                                feel good about ourselves.</p>
                                            <p><span className="brown brownbold">Finances</span> – The need for
                                                enough funds to live a fulfilling life.</p>
                                            <div className="border_subtitle">Step Two – Broaden and deepen your
                                                understanding
                                            </div>
                                            <ul className="greenbullet-list">
                                                <li>Reflect on the situation, then <span
                                                    className="subtiltereg">describe</span> it as fully and
                                                    comprehensively as you can.
                                                </li>
                                                <li>Identify ways in which the situation <span
                                                    className="subtiltereg">could be worse</span> and ways in
                                                    which it <span
                                                        className="subtiltereg">could be better.</span></li>
                                                <li>Explore ways in which the worst of those two versions could
                                                    really happen,<span className="subtiltereg"> to understand
how bad things</span> happen and what can be done to avoid them.
                                                </li>
                                                <li>Explore ways in which the better version could occur,
                                                    to <span
                                                        className="subtiltereg">understand what can be done</span> to
                                                    bring about a good result.
                                                </li>
                                                <li>Try to use the knowledge you have learned to <span
                                                    className="subtiltereg">put the event into perspective</span> and
                                                    to
                                                    consider ways of resolving it.
                                                </li>
                                            </ul>
                                            <div className="border_subtitle">Step Three – Take decisive action
                                            </div>
                                            <p>Hopefully, by now you’ve got an idea of the shape and size of
                                                your problem and understand it
                                                a little better. However, although you probably feel a bit
                                                relieved about it all, don’t stop there.</p>
                                            <ul className="greenbullet-list">
                                                <li>Now, you must resolve it. Put together an action plan, using
                                                    the following guide:
                                                </li>
                                                <li>Identify the goals of your action plan, working from your
                                                    newly gained understanding
                                                    of the problem.
                                                </li>
                                                <li>Explore, identify and document the actions you need to take
                                                    to achieve your goals.
                                                </li>
                                                <li>Set out SMART* objectives: <span
                                                    className="roundfsmall">S</span>pecific <span
                                                    className="roundfsmall">M</span>easurable <span
                                                    className="roundfsmall">A</span>greed <span
                                                    className="roundfsmall">R</span>ealistic <span
                                                    className="roundfsmall">T</span>imed
                                                </li>
                                                <li>Stick to your plan and do it (Remember, though, to revise it
                                                    if necessary).
                                                </li>
                                            </ul>
                                            <div className="uiheading sept"><p className="subText">*For further
                                                information on how to create an action plan see the tool ‘How to
                                                formulate action plans’.</p></div>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>SIX TOP TIPS
                                            </div>
                                            <p>In addition to building the 3 Cs and developing your
                                                transformational coping skills, try some
                                                of these tips<a className="superscripttext "
                                                                href="further_info.php?course=300"><sup>6</sup></a> as
                                                well, because they really work!</p>
                                            <div className="border_subtitle">Seek and accept the help of
                                                others
                                            </div>
                                            <p>Develop strong, open and honest relationships with colleagues,
                                                friends and family. They are a
                                                valuable source of support, feedback and help; make use of
                                                them.</p>
                                            <div className="border_subtitle">Make yourself laugh</div>
                                            <p>As the good doctor said,<span className="subtiltereg"> ‘laughter is the best medicine’.</span> Use
                                                laughter and humour to defuse
                                                the stress.</p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}